import styled, { css } from 'styled-components';

export interface ProgressBarInlineProps {
  progress?: number;
  isDone?: boolean;
  isFullWidth?: boolean;
}

const ProgressbarInline = styled.span<ProgressBarInlineProps>`
  width: 30px;
  height: 2px;
  border-radius: 2px;
  position: relative;
  display: block;
  margin-left: auto;
  background-color: ${({ theme }) => theme.colors.differentBackground};

  &:after {
    content: '';
    background-color: ${(props) =>
      props.isDone
        ? css`
            ${({ theme }) => theme.colors.success}
          `
        : css`
            ${({ theme }) => theme.colors.upload}
          `};
    border-radius: 2px;
    position: absolute;
    top: 0;
    right: auto;
    bottom: 0;
    left: 0;
    width: ${(props) => (props.progress ? props.progress : 0)}%;
    transition: width
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
    ${(props) => (props.isDone ? `width: 100%` : null)}
  }

  ${(props) =>
    props.isFullWidth
      ? css`
          position: absolute;
          right: 0;
          bottom: 0;
          left: 0;
          height: 3px;
          width: 100%;
          border-radius: 0;

          &:after {
            border-radius: ${props.isDone ? '0' : '0 0 2px 2px'};
          }
        `
      : null}
`;

export default ProgressbarInline;
